import { AfterViewInit, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { TaskStep, PrimaryData, ImagilityBaseResponse } from 'app-models';
import { HelpVideoOverlayLibraryComponent } from 'help-video-overlay-library';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { Subject } from 'rxjs/internal/Subject';
import { filter, takeUntil } from 'rxjs/operators';
// import { TaskNotesComponent } from 'src/app/modules/shared/task-notes/task-notes.component';
import { TimelineService } from './timeline.service';
import { VisaExtendedState } from '../../utility/interfaces/visa-extended-state';
import { Store } from '@ngrx/store';
import { updateStepStatus } from 'visa-store';
import { StepStatusUpdatePayloadService } from 'step-status-update-payload-service';
import { TaskNotesService } from 'task-notes-lib';
import { Router, NavigationEnd } from '@angular/router';
import { LockUnlockStepsLibraryService } from 'lock-unlock-steps-library';
import { NotificationDialogComponent } from '../notification-dialog/notification-dialog.component';
import { ReferenceLibraryService } from 'reference-library';

@Component({
  selector: 'app-visa-timeline',
  templateUrl: './i140-timeline.component.html',
  styleUrls: ['./i140-timeline.component.scss']
})
export class I140TimelineComponent implements OnInit, OnChanges, AfterViewInit {

  @Input()
  inputStepList: TaskStep[];

  @Input()
  selectedTaskType;

  @Input()
  receiptETADateRange;

  @Input()
  primaryData: PrimaryData;

  @Input()
  taskStatus: string;

  @Output()
  onStepClick: EventEmitter<TaskStep> = new EventEmitter();

  @ViewChild(HelpVideoOverlayLibraryComponent, { static: false }) helpVideoComponent: HelpVideoOverlayLibraryComponent;

  observableSubscription$ = new Subject();
  userType: string;
  public toolTipCustomClass: string = '';
  stepList: TaskStep[]; // Holding step list passed by pa rent
  isTaskReceiptDateAvailabel: boolean;
  dialogRef: DynamicDialogRef;
  private previousUrl: string = undefined;
  private currentUrl: string = undefined;
  isSimplify: boolean; 

  constructor(
    private apiService: TimelineService,
    public dialogService: DialogService,
    private store: Store<VisaExtendedState>,
    private stepStatusUpdatePayloadCostruction: StepStatusUpdatePayloadService,
    private taskNotesService: TaskNotesService,
    private lockService: LockUnlockStepsLibraryService,
    private router: Router,
    private referenceLibraryService: ReferenceLibraryService
  ) { 
    router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        this.previousUrl = this.currentUrl;
        this.currentUrl = event.url;
        sessionStorage.setItem('current-ULR', this.currentUrl);
      });
    this.stepList = [];
    this.userType = sessionStorage.getItem('userTypeRole');
    this.isTaskReceiptDateAvailabel = false;
  }

  ngOnInit(): void {    
    if(sessionStorage.getItem("isSimplify")=='CWF'){
      this.isSimplify = true;
    } else {
      this.isSimplify = false;
    }
  }

  ngAfterViewInit() {
    if (this.selectedTaskType === 'RFE') {
      if (this.userType !== 'Beneficiary') {
        this.helpVideoComponent.setTabValues(
          'right',
          'Building an RFE Response',
          'Part 1: Building an RFE Response',
          'Part 1: Building an RFE Response',
          'right',
          'Part 2: Building an RFE Response',
          'Part 2: Building an RFE Response'
        );
      }
    } else {
      if (this.userType !== 'Beneficiary') {
        this.helpVideoComponent?.setValues(
          'right',
          'Next steps after Tasks creation',
          'Next steps after Tasks creation'
        );
      } else {
        this.helpVideoComponent?.setValues(
          'right',
          'Using Timelines and Notifications for Beneficiary',
          'Using Timelines and Notifications for Beneficiary'
        );
      }
    }
    this.translet();
  }

  ngOnChanges(e: SimpleChanges) {
    if (e.inputStepList && e.inputStepList.currentValue) {
      sessionStorage.setItem('customStepTaskId', e.inputStepList.currentValue.find(item=> item.taskId).taskId);
      this.stepList = e.inputStepList.currentValue.map(x => {        
        return {
          ...x,
          isEditable:
            (this.userType === 'Attorney' &&
              x.isAttorneyEditable === 1 &&
              x.isAttorneyAction === 1) ||
            (this.userType === 'Beneficiary' &&
              x.isBeneficiaryEditable === 1 &&
              x.isBeneficiaryAction === 1) ||
            (this.userType === 'Petitioner' &&
              x.isPetitionerEditable === 1 &&
              x.isPetitionerAction === 1),
          isVisible:
            (this.userType === 'Attorney' && x.isAttorneyVisible === 1) ||
            (this.userType === 'Beneficiary' && x.isBeneficiaryVisible === 1) ||
            (this.userType === 'Petitioner' && x.isPetitionerVisible === 1),
          notesAdded:
            x.notes && x.notes[this.userType]
              ? x.notes[this.userType].noteText
              : ''
        };
        
      });

      this.translet();

      //this.updateNotesToSteps(null);
    }
    if (
      e.taskStatus &&
      e.taskStatus.currentValue &&
      e.taskStatus.currentValue === 'FILED'
    ) {
      this.apiService
        .getReceiptDetails(
          this.primaryData.visatype,
          this.primaryData.caseType,
          this.primaryData.caseId
        )
        .pipe(takeUntil(this.observableSubscription$))
        .subscribe((response: ImagilityBaseResponse) => {
          this.isTaskReceiptDateAvailabel =
            response &&
            response.data &&
            response.data.receiptDate &&
            response.data.receiptDate !== '';
        });
    }
  }

  handleStepClick(step: TaskStep) {
   // console.log("step",step);
    this.onStepClick.emit(step);
  }

  updateNoteAvailability(e, step) {
    step.notesAvailable = e?.notesAvailable || false;
    step.notes.noteText = e.noteText || '';
  }

  updateLockUnlock(e, step) {
    step.locked = e?.locked;
    step.taskId = e.taskId;
    step.stepId = e.stepId;
    step.userType = e.userType;
  }

  mouseEnter(param) {
    this.toolTipCustomClass = param;
  }

  onClickNofifications(step){
    this.dialogRef = this.dialogService.open(NotificationDialogComponent, {
      header: 'Notification',
      width: '90%',
      contentStyle: { 'max-height': '800px', overflow: 'auto' },
      data: {step: step}
    });
  }
  
  translet(){
    setTimeout(() => {
      this.referenceLibraryService.transletConversion();
    }, 600);  
  }
}
